export enum NetworkingStatus {
  Unknown = 'Unknown',
  Asleep = 'Asleep',
  Disconnected = 'Disconnected',
  Disconnecting = 'Disconnecting',
  Connecting = 'Connecting',
  ConnectedLocal = 'ConnectedLocal',
  ConnectedSite = 'ConnectedSite',
  ConnectedGlobal = 'ConnectedGlobal',
}

export const NetworkingStatusColor: Map<NetworkingStatus, string> = new Map([
  [NetworkingStatus.Unknown, 'gray'],
  [NetworkingStatus.Asleep, 'blue'],
  [NetworkingStatus.Disconnected, 'red'],
  [NetworkingStatus.Disconnecting, 'blue'],
  [NetworkingStatus.Connecting, 'blue'],
  [NetworkingStatus.ConnectedLocal, 'orange'],
  [NetworkingStatus.ConnectedSite, 'orange'],
  [NetworkingStatus.ConnectedGlobal, 'green'],
]);

export const NetworkingStatusLabel: Map<NetworkingStatus, string> = new Map([
  [NetworkingStatus.Unknown, 'unknown'],
  [NetworkingStatus.Asleep, 'asleep'],
  [NetworkingStatus.Disconnected, 'disconnected'],
  [NetworkingStatus.Disconnecting, 'disconnecting'],
  [NetworkingStatus.Connecting, 'connecting'],
  [NetworkingStatus.ConnectedLocal, 'locally connected'],
  [NetworkingStatus.ConnectedSite, 'connected to site'],
  [NetworkingStatus.ConnectedGlobal, 'globally connected'],
]);

export const NetworkingStatusDescription: Map<NetworkingStatus, string> = new Map([
  [NetworkingStatus.Unknown, 'The status is not known, probably due to a system error. Please check the logs for details.'],
  [NetworkingStatus.Asleep, 'Networking is not enabled, the system is being suspended or resumed from suspend.'],
  [NetworkingStatus.Disconnected, 'No active network connection.'],
  [NetworkingStatus.Disconnecting, 'Network connections are being cleaned up.'],
  [NetworkingStatus.Connecting, 'A network connection is being started.'],
  [NetworkingStatus.ConnectedLocal, 'Local IPv4 and/or IPv6 connectivity, but no default route to access the Internet.'],
  [NetworkingStatus.ConnectedSite, 'Only site-wide IPv4 and/or IPv6 connectivity. This means a default route is available, but the Internet connectivity check did not succeed.'],
  [NetworkingStatus.ConnectedGlobal, 'Global IPv4 and/or IPv6 Internet connectivity.'],
]);
